module.exports = __webpack_public_path__ + "static/HarshAgarwal-7821f988e183a4d5a8fb05ea263aa474.jpg";